import { Helmet } from "react-helmet-async";

export default function JsonLd() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SoverX",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, On-Premise, Private Cloud",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock"
    },
    "description": "Enterprise AI platform for secure, sovereign, and air-gapped artificial intelligence deployment.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "150"
    },
    "author": {
      "@type": "Organization",
      "name": "SoverX.ai",
      "url": "https://soverx.ai"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SoverX.ai",
    "url": "https://soverx.ai",
    "logo": "https://soverx.ai/images/soverx-logo.png",
    "sameAs": [
      "https://www.linkedin.com/company/soverx/",
      "https://twitter.com/soverx_ai"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+55-11-99999-9999",
      "contactType": "sales",
      "areaServed": ["BR", "US", "EU"],
      "availableLanguage": ["Portuguese", "English", "Spanish"]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
}
